<div *ngIf="isVisible" class="bo-feedback bo-feedback--warning bo-banner">
  <span class="bo-feedback__icon" aria-hidden="true"><i class="bi bi-phone"></i></span>
  <div class="bo-banner__copy" role="status">
    <p class="bo-banner__message">{{ 'mobile_warning_message' | translate }}</p>
  </div>
  <button type="button" class="bo-feedback__close" (click)="dismiss()" [attr.aria-label]="'ac_close' | translate">
    <i class="bi bi-x" aria-hidden="true"></i>
  </button>
</div>
